export default "__VITE_ASSET__e0562cec__"